import { CLEAR_APPLICATION_DATA, SAVE_PDE_INFO } from "../constant";

export const pdeApplicationInitialState = (data) => {
	return {
		personalInfoResponse: {
			id: data?.personalInfoResponse?.id ?? null,
			PassportAsBase64: data?.passport,
			regNumber: data?.regNumber,
			surname: data?.personalInfoResponse?.surname,
			firstname: data?.personalInfoResponse?.firstname,
			lastname: data?.personalInfoResponse?.lastname,
			nin: data?.nin,
			middlename: data?.personalInfoResponse?.middlename,
			homeTown: data?.personalInfoResponse?.homeTown,
			disability: data?.personalInfoResponse?.disability,
			otherNames: data?.personalInfoResponse?.otherNames,
			...(data?.personalInfoResponse?.genderId && {
				genderId: {
					value: data?.personalInfoResponse?.genderId,
					label: data?.personalInfoResponse?.gender
				}
			}),
			dateOfBirth: data?.personalInfoResponse?.dateOfBirth,
			...(data?.personalInfoResponse?.countryId && {
				countryId: {
					value: data?.personalInfoResponse?.countryId,
					label: data?.personalInfoResponse?.country
				}
			}),
			...(data?.personalInfoResponse?.state && {
				stateId: {
					value: data?.personalInfoResponse?.stateId,
					label: data?.personalInfoResponse?.state
				}
			}),
			...(data?.personalInfoResponse?.lga && {
				lgaId: {
					value: data?.personalInfoResponse?.lgaId,
					label: data?.personalInfoResponse?.lga
				}
			}),
			permanentAddress: data?.personalInfoResponse?.permanentAddress,
			contactAddress: data?.personalInfoResponse?.contactAddress,
			mobileNumber: data?.personalInfoResponse?.mobileNumber,
			...(data?.personalInfoResponse?.religionId && {
				religionId: {
					value: data?.personalInfoResponse?.religionId,
					label: data?.personalInfoResponse?.religion
				}
			}),
			email: data?.personalInfoResponse?.email,
			numberOfChildren: data?.personalInfoResponse?.numberOfChildren,
			...(data?.personalInfoResponse?.maritalStatusId && {
				maritalStatusId: {
					value: data?.personalInfoResponse?.maritalStatusId,
					label: data?.personalInfoResponse?.maritalStatus
				}
			})
		},
		nextOfKin: {
			fullname: data?.personalInfoResponse?.nextOfKinFullName,
			...(data?.personalInfoResponse?.nextOfKinRelationshipId !==
				null && {
				relationshipId: {
					value: data?.personalInfoResponse?.nextOfKinRelationshipId,
					label: data?.personalInfoResponse?.nextOfKinRelationship
				}
			}),
			mobileNumber: data?.personalInfoResponse?.nextOfKinMobileNumber,
			address: data?.personalInfoResponse?.nextOfKinContactAddress
		},
		programmeInfo: {
			applicationType: data?.applicationType ?? null,
			applicationTypeId: data?.applicationTypeId ?? null,
			rrr: data?.programmeInfoResponse?.rrr ?? null,

			facultyId:
				data?.programmeInfoResponse?.facultyId != null
					? {
							value: data.programmeInfoResponse.facultyId,
							label: data.programmeInfoResponse.faculty
					  }
					: null,
			alternateFacultyId:
				data?.programmeInfoResponse?.alternateFacultyId != null
					? {
							value: data.programmeInfoResponse
								.alternateFacultyId,
							label: data.programmeInfoResponse.alternateFaculty
					  }
					: null,

			departmentId:
				data?.programmeInfoResponse?.departmentId != null
					? {
							value: data.programmeInfoResponse.departmentId,
							label: data.programmeInfoResponse.department
					  }
					: null,
			programmeCategoryId:
				data?.programmeInfoResponse?.programmeCategoryId != null
					? {
							value: data.programmeInfoResponse
								.programmeCategoryId,
							label: data.programmeInfoResponse.programmeCategory
					  }
					: null,
			programmeTypesId:
				data?.programmeInfoResponse?.programmeTypeId != null
					? {
							value: data.programmeInfoResponse.programmeTypeId,
							label: data.programmeInfoResponse.programmeType
					  }
					: null,
			alternativeDepartmentId:
				data?.programmeInfoResponse?.alternateDepartmentId != null
					? {
							value: data.programmeInfoResponse
								.alternateDepartmentId,
							label: data.programmeInfoResponse
								.alternateDepartment
					  }
					: null,

			jambNumber: data?.regNumber,

			departmentOptionId:
				data?.programmeInfoResponse?.departmentOptionId != null
					? {
							value: data.programmeInfoResponse
								.departmentOptionId,
							label: data.programmeInfoResponse.departmentOption
					  }
					: null,

			programmeId:
				data?.programmeInfoResponse?.programmeId != null
					? {
							value: String(
								data.programmeInfoResponse.programmeId
							),
							label: data.programmeInfoResponse.programme
					  }
					: null,

			firstSubjectId:
				data?.programmeInfoResponse?.firstSubjectId != null
					? {
							value: data.programmeInfoResponse.firstSubjectId,
							label: data.programmeInfoResponse.firstSubject
					  }
					: null,

			secondSubjectId:
				data?.programmeInfoResponse?.secondSubjectId != null
					? {
							value: data.programmeInfoResponse.secondSubjectId,
							label: data.programmeInfoResponse.secondSubject
					  }
					: null,

			thirdSubjectId:
				data?.programmeInfoResponse?.thirdSubjectId != null
					? {
							value: data.programmeInfoResponse.thirdSubjectId,
							label: data.programmeInfoResponse.thirdSubject
					  }
					: null,

			fourthSubjectId:
				data?.programmeInfoResponse?.fourthSubjectId != null
					? {
							value: data.programmeInfoResponse.fourthSubjectId,
							label: data.programmeInfoResponse.fourthSubject
					  }
					: null,

			utmeScore: data?.programmeInfoResponse?.utmeScore ?? null
		},
		NCEResultHistoryResponse: {
			courseStudied: data?.nceResultResponse?.courseStudied ?? "",
			graduationDate:
				data?.nceResultResponse?.graduationDate ?? "",
			cgpa: data?.nceResultResponse?.cgpa ?? "",
			sessionOfQualificationId:
				data?.nceResultResponse?.sessionOfQualificationId != null
					? {
							value: data.nceResultResponse
								.sessionOfQualificationId,
							label: data.nceResultResponse
								.sessionOfQualification
					  }
					: null,
			serialNo: data?.nceResultResponse?.serialNo ?? "",
			awardingInstitution:
				data?.nceResultResponse?.awardingInstitution ?? "",
			regNumber: data?.regNumber ?? ""
		},

		postUtmeEducationHistoryResponse:
			data?.educationHistoryResponse?.length > 0
				? data?.educationHistoryResponse.map((education) => ({
						...education,
						startDate: education?.yearFrom,
						endDate: education?.yearTo,
				  }))
				: [],

		studentTypeId: data?.studentTypeId,

		oLevelResult: {
			sittings: data?.olevelResponse?.map((item) => ({
				...item,
				resultPin: item?.resultPin,
				resultPinSno: item?.resultSerialNumber,
				examNumber: item?.examNumber,
				examCentre: item?.examCenter,
				oLevelType: {
					value: item?.examinationTypeId,
					label: item?.examinationType
				},
				examYear: { value: item?.examYear, label: item?.examYear },
				subjects: [
					...Object?.keys(item?.subjectGrade).map((key, index) => ({
						subject: {
							label: key?.toUpperCase(),
							value: Object?.keys(item?.subjectGradeId)?.[index]
						},
						grade: {
							label: item?.subjectGrade?.[key],
							value: Object?.values(item?.subjectGradeId)?.[index]
						}
					}))
				]
			}))
		},
		certificates:
			data?.certificates?.map((certificate) => ({
				...(certificate.certificateType && {
					certificate: certificate.certificate,
					certificateTypeId: {
						value: certificate.certificateTypeId,
						label: certificate.certificateType
					}
				})
			})) ?? []
	};
};

export const pdeReducer = (state = {}, action) => {
	switch (action.type) {
		case SAVE_PDE_INFO:
			return action.payload;
		case CLEAR_APPLICATION_DATA:
			return {};
		default:
			return state;
	}
};
